import React from 'react';
import { Icon } from '@iconify/react';
import plusSquareOutline from '@iconify/icons-eva/plus-square-outline';
import minusSquareOutline from '@iconify/icons-eva/minus-square-outline';
import closeSquareOutline from '@iconify/icons-eva/close-square-outline';
import { Box } from '@material-ui/core';
// ----------------------------------------------------------------------
const ICON_SIZE = { width: 20, height: 20 };
export const TreeView = ({ theme }) => {
    return {
        MuiTreeView: {
            defaultProps: {
                defaultCollapseIcon: React.createElement(Icon, Object.assign({ icon: minusSquareOutline }, ICON_SIZE)),
                defaultExpandIcon: React.createElement(Icon, Object.assign({ icon: plusSquareOutline }, ICON_SIZE)),
                defaultEndIcon: (React.createElement(Box, Object.assign({ component: Icon, icon: closeSquareOutline }, ICON_SIZE, { sx: { color: 'text.disabled' } })))
            }
        },
        MuiTreeItem: {
            styleOverrides: {
                label: Object.assign({}, theme.typography.body2),
                iconContainer: { width: 'auto' }
            }
        }
    };
};
//# sourceMappingURL=TreeView.js.map